import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { ALK_EVENT_TYPE, AlkEvent, BaseView, ChronocodeCmd, FastSelectData, FindConnectCommand, FindCssRenderCommand, FindFormatCommand, FindMeasureCommand, FindStyleCommand, FreedataCall, GridsterWidget, PhysicalTemplateCmd, PhysicalTemplateEngine, PhysicalTemplateVO, ViewData, WIDGET_GLOBAL_KIND, WorkcomCall } from '@wizeoo/akm-common-lib';
import { WizActionObj, WizCommand, WizEventManager, WizGroupCommand, WizRoot, WizVgroup } from '@wizeoo/akm-component-lib';
import { DisplayGrid, GridsterComponent } from 'angular-gridster2';
import { APP_EVENT_TYPE } from 'src/app/model/enums';
import { Model } from 'src/app/model/model';

@Component({
  selector: 'add-view',
  templateUrl: './add.view.html',
})
// Vue d'initialisation pour chargement du contexte
export class AddView extends BaseView {

  @ViewChild('container', { static: true }) container!: WizVgroup;
  @ViewChild('meGridster', { static: true }) meGridster!: GridsterComponent;


  constructor(public elementRef: ElementRef, public cdref: ChangeDetectorRef ) {
    super(elementRef);
    this.code = 'ADD';
  }

  public templateCode: string = 'FORM';


  wizBeforeInit(): boolean | Promise<any>[] | WizGroupCommand | WizCommand<any> {

    const calls = [];
    // disponibilité des freedatas pour labels
   if (!Model.getInstance().chronocodeEngine.getChronocodesMap()) {
      // disponibilité des chronocodes pour labels
      calls.push(new ChronocodeCmd(Model.getInstance()).find());
    }
    // disponibilité des freedatas pour labels
    if (!Model.getInstance().freedataEngine.getFreedataMap()) {
      calls.push(new FreedataCall(Model.getInstance()));
    }
    if (!Model.getInstance().measureEngine.getMeasureList()) {
      // vérification des measures
      calls.push(new FindMeasureCommand(Model.getInstance()));
    }

    const physOK: boolean = Model.getInstance().physicalTemplateMap?.get(Model.getInstance().businessUnitCode)?.has(Model.getInstance().visionCode);

    if (!physOK) {
      calls.push(new PhysicalTemplateCmd(Model.getInstance()).find());
    }

    if (!Model.getInstance().styleList) {
      calls.push(new FindStyleCommand(Model.getInstance()));
    }
    if (!Model.getInstance().connectMapExt) {
      // chargement de la liste des fonctions de connexion
      calls.push(new FindConnectCommand(Model.getInstance()));
    }
    // chargement de la liste des formats
    if (!Model.getInstance().formatEngine.getFormatList()) {
      // double appel pour format de base à la bu (*)
      calls.push(new FindFormatCommand(Model.getInstance()).find(ViewData.wildcardDomain, ViewData.wildcardDomain));
      calls.push(new FindFormatCommand(Model.getInstance()).find(Model.getInstance().domainCode, Model.getInstance().businessUnitCode));
    }
    // chargement de la liste des rendus css
    if (!Model.getInstance().styleEngine.getCssRenderList()) {
      calls.push(new FindCssRenderCommand(Model.getInstance()).find(Model.getInstance().domainCode, Model.getInstance().businessUnitCode));
    }

    // chargement des messages
    if (!Model.getInstance().workflowEngine.getWorkcomMap()) {
      calls.push(new WorkcomCall(Model.getInstance()));
    }


    if (calls.length > 0) {
      return new WizGroupCommand().configure(calls);
    } else {
      return true;
    }

  }

  wizAddListener() {
    super.wizAddListener();
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.WIDGET_READY, this.feedProto); 
  }

  wizRemoveListener() {
    super.wizRemoveListener();
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.WIDGET_READY);
  }

  private feedProto(e: AlkEvent): void {
    //setTimeout(() => {
    setTimeout(() => {
      if(!!Model.getInstance().currentPrototype) {
        let fsd: FastSelectData = {fei: null, kind: WIDGET_GLOBAL_KIND.FREEDATA, data: Model.getInstance().currentPrototype};
        WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.PROGRAMMATIC_FEED, fsd));
      }
    }, 100);
  }

  public template: PhysicalTemplateVO = null;
  public options: any = PhysicalTemplateEngine.gridsterSafe();
  public tabWidgets: GridsterWidget[]; // la liste des widgets de cette vue


  /**
   * Synchronisation des données
   */
  public wizSynchronizeData(): void {
    
    Model.getInstance().currentViewCode = this.code;
    // alimentation du bread
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(APP_EVENT_TYPE.BREAD, '$.widget.show.add.$'));


    // prise du bon template
    this.template = Model.getInstance().physicalTemplateEngine.getTemplate(this.templateCode);

    
    // conf de base gridster
    this.options = Model.getInstance().physicalTemplateEngine.gridsterOption();
    this.options.gridType = this.template?.screenMode || ViewData.DEFAULT_SCREEN_MODE;
    this.options.outerMargin = false;
    this.options.draggable.enabled = false;
    this.options.resizable.enabled = false;
    this.options.mobileBreakpoint= 100;
    this.options.displayGrid = DisplayGrid.None; //  DisplayGrid.None;
    this.options.margin = 5;

    this.feedTab();
    this.feed();

  }

  private feedTab(): void {
    let wao: WizActionObj = new WizActionObj(this.templateCode, null, null);
    wao.featureCode = Model.getInstance().visionCode + ViewData.KEY_SEPARATOR + this.code;
    ViewData.currentTab = wao;
  }


  private feed(): void {
    if(this.template) {
      // alimentation de la map de widget de l'engine
      Model.getInstance().widgetEngine.widgetConfigMap = new Map(this.template.widgets.map((gw: GridsterWidget) => [gw.uid, gw]));
      
      // neutralisation des couleurs de headers
      this.template.widgets.forEach(gw => {
        gw.source.wco.r?.forEach(wcio => {
          wcio.hsty = null;
        });
      });

      this.tabWidgets = this.template.widgets;
    } else {
      this.tabWidgets = [];
    }

    this.meGridster.optionsChanged();

    setTimeout(() => {
      this.cdref.markForCheck();
    }, 0);
  }

  /** injection correcte du GiVO dans les widgets... Cette merde de Gridster flingue les getter / setters */
  public getRealVOFromGridsterLimitation(item: GridsterWidget): GridsterWidget {
    let res: GridsterWidget = null;
    this.tabWidgets.forEach((givo: GridsterWidget) => {
      if (givo.uid === item.uid) {
        res = givo;
        // console.log('givo', givo);
        // console.log('item:{x:', givo.x, ", y:", givo.y, ' cols:', givo.cols, ' rows:', givo.rows, '}');
      }
    });
    return res;
  }


}